import { SVGProps } from 'react';

const ClockScaleExtraSmallKindRewind = (props: SVGProps<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0.5 2.00001V5.00001M0.5 5.00001H3.5M0.5 5.00001L2.82 2.82001C3.51046 2.13072 4.40623 1.68449 5.37234 1.54856C6.33845 1.41264 7.32257 1.59437 8.17642 2.06639C9.03026 2.5384 9.70758 3.27513 10.1063 4.16555C10.505 5.05598 10.6036 6.05188 10.3871 7.00319C10.1706 7.95449 9.65084 8.80968 8.90606 9.43988C8.16129 10.0701 7.23187 10.4412 6.25786 10.4972C5.28384 10.5533 4.31799 10.2913 3.50583 9.75069C2.69367 9.2101 2.0792 8.42019 1.755 7.50001M6 3.50001V6.00001L8 7.00001"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ClockScaleExtraSmallKindRewind;
